import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, Validators, AbstractControl, ReactiveFormsModule } from '@angular/forms';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogTitle,
} from '@angular/material/dialog';
import { DialogData } from '../../../../shared/models/dialog-data.model';
import { CertificateType } from '../../../../shared/models/certificate-type.enum';
import { MatButtonModule } from '@angular/material/button';
import { InputField } from '../../../../shared/components/input-field/input-field';

@Component({
  selector: 'app-import-ssl-certificate-dialog',
  imports: [
    ReactiveFormsModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButtonModule,
    InputField,
  ],
  templateUrl: './import-ssl-certificate-dialog.component.html',
  styleUrl: './import-ssl-certificate-dialog.component.scss',
})
export class ImportSslCertificateDialogComponent implements OnInit {
  readonly dialogRef = inject(MatDialogRef<ImportSslCertificateDialogComponent>);

  readonly data = inject<DialogData & { websiteId: number }>(MAT_DIALOG_DATA);

  private fb = inject(FormBuilder);

  certificateTypeOptions: { label: string; value: string }[] = [
    {
      value: CertificateType.LetsEncrypt,
      label: 'LetsEncrypt',
    },
    {
      value: CertificateType.Custom,
      label: 'Custom',
    },
    {
      value: CertificateType.SelfSigned,
      label: 'Self-Signed',
    },
  ];

  readonly VALIDATORS = {
    type: [Validators.required],
    certificate: [
      (control: AbstractControl) => {
        if (!control.value) return { required: 'Certificate is required' };

        if (!control.value.startsWith('-----BEGIN CERTIFICATE-----'))
          return { certificateError: 'Certificate is invalid' };

        if (!control.value.endsWith('-----END CERTIFICATE-----\n'))
          return { certificateError: 'Certificate is invalid' };
        return null;
      },
    ],
    ca: [
      (control: AbstractControl) => {
        if (!control.value) return null;

        if (!control.value.startsWith('-----BEGIN CERTIFICATE-----'))
          return { caBundleError: 'CA Bundle is invalid' };

        if (!control.value.endsWith('-----END CERTIFICATE-----\n'))
          return { caBundleError: 'CA Bundle is invalid' };
        return null;
      },
    ],
    key: [
      (control: AbstractControl) => {
        if (!control.value) return { required: 'Key is required' };

        if (!control.value.startsWith('-----BEGIN PRIVATE KEY-----'))
          return { keyError: 'Private Key is invalid' };

        if (!control.value.endsWith('-----END PRIVATE KEY-----\n'))
          return { keyError: 'Private Key is invalid' };
        return null;
      },
    ],
  };

  readonly ERROR_MESSAGES: Record<string, Record<string, string>> = {
    certificate: {
      required: 'Certificate is required',
      certificateError: 'Certificate is invalid',
    },
    key: {
      required: 'Key is required',
      keyError: 'Private Key is invalid',
    },
    ca: {
      required: 'CA Bundle is required',
      caBundleError: 'CA Bundle is invalid',
    },
  };

  form = this.fb.nonNullable.group({
    type: [''],
    websiteId: [0],
    certificate: ['', this.VALIDATORS.certificate],
    ca: ['', this.VALIDATORS.ca],
    key: ['', this.VALIDATORS.key],
  });

  ngOnInit(): void {
    this.form.controls.websiteId.setValue(this.data.websiteId);
    // this.form.controls.type.valueChanges.subscribe((value) => {});
  }

  submit(): void {
    if (this.form.invalid) return;
    this.dialogRef.close(this.form.getRawValue());
  }

  close(): void {
    this.dialogRef.close();
  }
}
